import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/quantity-unit";

// export const getAllQuantityUnit = () => axios.get(API_PATH + "/get-all-QuantityUnit");

export const pagingQuantityUnit = (searchObject) => axios.post(API_PATH + "/getPage", searchObject);

export const getQuantityUnitById = (quantityUnitId) => axios.get(API_PATH + "/" + quantityUnitId);

export const createQuantityUnit = quantityUnit => axios.post(API_PATH, quantityUnit);

export const updateQuantityUnit = quantityUnit => axios.put(API_PATH + '/' + quantityUnit?.id, quantityUnit);

export const deleteQuantityUnitById = quantityUnitId => axios.delete(API_PATH + '/' + quantityUnitId);

export const saveQuantitySyncStore = data => axios.post(API_PATH + '/sync-quantity-unit' , data);

// export const getQuantityUnitByCode = quantityUnit => axios.get(API_PATH + '/find-by-code/' + quantityUnit);